import { Fragment, useContext } from 'react';

import ModalSignup from 'components/modal/signups';
import VideoModal from 'components/modal/video';

import { ScheduleDemoWizardContext } from '../schedule-demo-wizard';
import { PromoText } from '../types/config';
import { ScheduleDemoMercuryAction } from '../util/send-mercury-event';

type Props = {
  textConfig: PromoText
  wistiaVideoHashedId: string
}

const VideoDemoPromoStep = (props:Props) => {

  const { emitEvent } = useContext(ScheduleDemoWizardContext);

  const handleModalOpen = () => {
    emitEvent({
      action: ScheduleDemoMercuryAction.VIDEO_DEMO_BUTTON_CLICKED,
    });
  };

  return (
    <Fragment>
      <h1 className="schedule-demo-wizard--title">
        {props.textConfig.title}
      </h1>
      <p className="schedule-demo-wizard--copy">
        {props.textConfig.copy}
      </p>
      <h2 className="schedule-demo-wizard--sub-title">{ props.textConfig.subTitle1 }</h2>
      <VideoModal
        className="button is-rounded green-pill-button mb-5"
        hashedId={ props.wistiaVideoHashedId }
        modalOpenedCallback={ handleModalOpen }
        text={ props.textConfig.button }
      />

      <h2 className="schedule-demo-wizard--sub-title">{ props.textConfig.subTitle2 }</h2>
      <ModalSignup
        showModalButton
        signupModalLaunch={ props.textConfig.button2 }
        buttonClasses="button is-rounded green-pill-button schedule-demo-start-free-trial-button mb-3"
        modalOpenCallback={ handleModalOpen }
      />
    </Fragment>
  );
};

export default VideoDemoPromoStep;
